import React from 'react';
import '../Styles/Login.scss';

const Login = () => {
  return (
    <div className="login">
      <div className="login__container">
        <div className="login__logo">
          <img src="path/to/logo.png" alt="Logo" /> {/* Remplace par le chemin de ton logo */}
        </div>
        <h1 className="login__title">Login</h1>
        <p className="login__subtitle">See your growth and get consulting support!</p>
        <form className="login__form">
          <div className="login__input-group">
            <label htmlFor="email">Email*</label>
            <input type="email" id="email" placeholder="mail@website.com" required />
          </div>
          <div className="login__input-group">
            <label htmlFor="password">Password*</label>
            <input type="password" id="password" placeholder="Min. 8 characters" required />
          </div>
          <div className="login__options">
            <div className="login__remember">
              <input type="checkbox" id="remember" />
              <label htmlFor="remember">Remember me</label>
            </div>
            <a href="#" className="login__forgot">Forget password?</a>
          </div>
          <button type="submit" className="login__button">Login</button>
        </form>
        <p className="login__register">
          Not registered yet? <a href="#">Create an Account</a>
        </p>
        <footer className="login__footer">©2020 Felix All rights reserved.</footer>
      </div>
    </div>
  );
};

export default Login;
